import { createContext } from 'react';
export const RichTextDisplayContext = createContext({
    defaultRichTextDisplayValue: true,
});
//# sourceMappingURL=RichTextDisplayContext.js.map